import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { HealthUnitDataRequest } from '../../requests/billing/health-unit-data.request';

@Injectable({
  providedIn: 'root'
})
export class HealthUnitDataService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  saveHealthUnitData(body: HealthUnitDataRequest): Observable<ReturnStruct>{
    let uri = `HealthUnitData`
      
    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBilling) + uri, body, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
